function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { Box } from "..";
import PropTypes from 'prop-types';

var animation = function animation(props) {
  return keyframes(["0%{transform:translateX(-200px)}100%{transform:translateX(", "px)}"], props.animationWidth);
};

var animationRule = css(["", " 1.2s ease-in-out infinite;"], animation);
var Wrapper = styled(Box).withConfig({
  displayName: "Shimmer__Wrapper",
  componentId: "sc-4d6lwi-0"
})(["background-color:#eee;background-size:200px 100%;background-repeat:no-repeat;display:inline-block;line-height:1;", " overflow:hidden;"], function (props) {
  return props.height && "height: ".concat(props.height, ";");
});
var Glare = styled.span.withConfig({
  displayName: "Shimmer__Glare",
  componentId: "sc-4d6lwi-1"
})(["display:inline-block;background-image:linear-gradient( to right,rgba(245,245,245,0) 0%,rgba(245,245,245,1) 50%,rgba(245,245,245,0) 100% );background-image:-webkit-linear-gradient( left,rgba(245,245,245,0) 0%,rgba(245,245,245,1) 50%,rgba(245,245,245,0) 100% );animation:", ";height:100%;width:200px;@media (prefers-reduced-motion){animation:none;}"], animationRule);

var Shimmer = function Shimmer(_ref) {
  var animationWidth = _ref.animationWidth,
      disable = _ref.disable,
      props = _objectWithoutProperties(_ref, ["animationWidth", "disable"]);

  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, props, {
    "data-testid": "Shimmer__Wrapper"
  }), !disable && /*#__PURE__*/React.createElement(Glare, {
    animationWidth: animationWidth + 200,
    "data-testid": "Shimmer__Glare"
  }, "\u200C"));
};

Shimmer.defaultProps = {
  animationWidth: 100,
  disable: false
};
Shimmer.propTypes = _objectSpread(_objectSpread({}, Box.propTypes), {}, {
  animationWidth: PropTypes.number,
  className: PropTypes.string,
  disable: PropTypes.bool
});
export default Shimmer;